import axios from 'axios'
//引入进度条插件
import NProgress from 'nprogress';
//引入进度条的样式
import 'nprogress/nprogress.css'


const requests = axios.create({
    baseURL: '',
    timeout: 10000,
    withCredentials: true, //让ajax携带cookie/session
})


// 添加请求拦截器
requests.interceptors.request.use((config) => {
    //在发送请求之前做些什么
    // config.headers.token = localStorage.getItem("token") || "";
    //进度条开始动
    NProgress.start()
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  });

// 添加响应拦截器
requests.interceptors.response.use((res) => {
    // 对响应数据做点什么
    if (res.status == 200) {
      if (res.data.code === 401) {
        // const adminStore = useAdminStore();
        ElMessage({
          type: "info",
          message:res.data.msg,
        });
        // adminStore.loginOut(); // 退出登录
        return Promise.reject(res);
      }
      return Promise.resolve(res);
    } else {
      return Promise.reject(res);
    }
    //进度条结束
    NProgress.done()
    return res.data;
  },
  (error) => {
    // 超时处理
    let originalRequest = error.config;
    if (
      error.code === "ECONNABORTED" &&
      error.message.indexOf("timeout") !== -1 &&
      !originalRequest._retry
    ) {
      ElMessage({
        type: "error",
        message: "请检查网络再重新连接",
      });
      return Promise.reject("请检查网络再重新连接");
    }
    if (error.response.status) {
      return Promise.reject(error.response);
    }
    // 对响应错误做点什么
    // return Promise.reject(error);
  });

export default requests



// WEBPACK FOOTER //
// ./src/api/index.js